<h2 mat-dialog-title>
  ADD PLAYER
</h2>
<form class="example-form" [formGroup]='playersForm'>
  <mat-form-field style="margin-left: 20px; width: 300px;">
    <input matInput placeholder="Enter name to search for"  formControlName='userInput' required (keyup)="doFilter($event.target.value)">
  </mat-form-field>
  <!--  <button mat-button type="button" (click)="search()">SEARCH</button> -->
</form>
<mat-list mat-dialog-content style="height: 350px; background-color: #303030 ">
  @for (player of this.filteredPlayers; track player) {
    <mat-list-item >
      <span matListItemTitle>
        <button mat-raised-button (click)="addPlayer(player.LifelineScoutingId)">
          ADD
        </button>
        {{player.LastName}}, {{player.FirstName}} ({{this.positionNames[player.PositionId]}})
      </span>
      <span matListItemLine style="margin-left: 66px;">
        {{player.DateOfBirth | date:'yyyy-MM-dd'}}
      </span>
    </mat-list-item>
  }

</mat-list>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial >CLOSE</button>


</div>